export default class Pedidos {

    constructor(resource) {
        this._resource = resource('pedidos_supo');
    }

    getAll() {
        return this._resource
            .get()
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    get(rid) {
        return this._resource
            .get(
                {
                    rid: rid,
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getPedidoImpressao(rid) {
        return this._resource
            .get(
                {
                    rid: rid,
                    rimp: true
                })
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

    save(rdados) {
        return this._resource
            .save({}, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    up(rID) {
        return this._resource
            .update({ rID: rID }, [])
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    del(rID) {
        return this._resource
            .delete({ rID: rID }, [])
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

}